<template>
    <div v-if="!loading">
        <div v-if="storeslist.length">
            <b-row>
                <b-col v-for="(item, index) in storeslist" :key="index" cols="6" xl="2" lg="2" md="3" sm="4">
                    <div style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);" class="mb-2 rounded border">
                        <div class="text-center p-1 text-truncate">
                            {{ item.storeName }}
                        </div>
                        <div class="rounded w-100" style="height: 150px;">
                            <img v-if="item.newLogoImage" :src="BASE_URL_File + item.newLogoImage"
                                class="w-100 h-100 rounded">
                            <img v-if="item.newAvatarImage" :src="BASE_URL_File + item.newAvatarImage"
                                class="w-100 h-100 rounded">
                            <img v-if="item.newDefaultProductImage" :src="BASE_URL_File + item.newDefaultProductImage"
                                class="w-100 h-100 rounded">
                        </div>
                        <div class="d-flex">
                            <b-button @click="pendingStoresChangeStatus(item, true)" variant="flat-primary"
                                class="w-50">
                                <feather-icon icon="CheckIcon" size="18" />
                            </b-button>
                            <b-button @click="pendingStoresChangeStatus(item, false)" variant="flat-secondary"
                                class="w-50">
                                <feather-icon icon="XIcon" size="18" />
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div v-else class="text-center">
            موردی وجود ندارد
        </div>
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BTable, BPagination, BFormInput } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BImg,
        BAvatar,
        BTable,
        BPagination,
        BFormInput
    },
    data() {
        return {
            loading: true,
            storeslist: [],
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            parameters: {
                pageIndex: 1,
                pageSize: 99,
                totalCount: null
            },
        }
    },
    methods: {
        async getPendingStores() {
            this.loading = true
            adminService.pendingStores(this.parameters).then(({ data }) => {
                this.storeslist = []
                this.parameters.totalCount = data.totalCount
                if (data.items.length) {
                    data.items.forEach(obj => {
                        if (obj.newAvatarImage) {
                            this.storeslist.push({
                                newAvatarImage: obj.newAvatarImage,
                                newLogoImage: null,
                                newDefaultProductImage: null,
                                storeId: obj.storeId,
                                storeName: obj.storeName
                            })
                        }
                        if (obj.newLogoImage) {
                            this.storeslist.push({
                                newLogoImage: obj.newLogoImage,
                                newAvatarImage: null,
                                newDefaultProductImage: null,
                                storeId: obj.storeId,
                                storeName: obj.storeName
                            })
                        }
                        if (obj.newDefaultProductImage) {
                            this.storeslist.push({
                                newLogoImage: null,
                                newAvatarImage: null,
                                newDefaultProductImage: obj.newDefaultProductImage,
                                storeId: obj.storeId,
                                storeName: obj.storeName
                            })
                        }
                    });
                }
                this.loading = false
            })
        },
        pendingStoresChangeStatus(item, accept) {
            let data = {
                id: item.storeId
            }
            if (item.newLogoImage) {
                data.acceptLogo = accept
            }
            if (item.newAvatarImage) {
                data.acceptAvatar = accept
            }
            if (item.newDefaultProductImage) {
                data.acceptDefaultProductImage = accept
            }
            adminService.pendingStoresChangeStatus(data).then(({ data }) => {
                this.getPendingStores()
                this.$notif({ type: 'success' });
            })
        },

    },
    mounted() {
        this.getPendingStores()
    },
};
</script>


<style>
.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>